
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
const Layout = _Layout;
const meta = {
  "id": "commission",
  "title": "Commission",
  "sidebar_label": "Commission"
};
const slug = 'commission';
const tableOfContents = [{
  "title": "Example of % commission from each sales and deals",
  "slug": "example-of-commission-from-each-sales-and-deals",
  "children": []
}, {
  "title": "How to Configure Commission Model",
  "slug": "how-to-configure-commission-model",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">






    <p>{`Commission-based revenue models are the most common in marketplace business. Companies like Amazon, Aliexpress, airbnb Etsy, Depop, Farfetch, Udemy, Upwork charges you on the commission of supply side or demand side. `}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#014b3b9a-cd65-4e99-af54-d88452e20145"
      }}>{`API REFERENCE`}</a>{` | `}<a parentName="p" {...{
        "href": "https://superadmin.tradly.app/commission"
      }}>{`Visit SuperAdmin`}</a></p>
    <_Heading level={2} id={"example-of-commission-from-each-sales-and-deals"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>Example of % commission from each sales and deals</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`% of Commission from seller/merchants/accounts (Amazon)`}</li>
      <li parentName="ol">{`% of commmission from Buyer (Property marketplaces)`}</li>
      <li parentName="ol">{`% of commission from both buyer and seller (airbnb) `}</li>
      <li parentName="ol">{`% of commission from buyer, seller, and delivery (Deliveroo, Uber Eats)`}</li>
    </ol>
    <_Heading level={2} id={"how-to-configure-commission-model"} nextElement={{
      "type": "paragraph"
    }}>How to Configure Commission Model</_Heading>
    <p>{`Currently, through Superadmin Panel, you can configure commission-based model on supply side. However, we allow commission on buyer side as well. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Currently, commission-based revenue model is using Stripe Connect. So, the transaction fee and payout fee defined by stripe and might vary on your business region, refer from there. `}<a parentName="li" {...{
          "href": "https://stripe.com/au/connect/pricing"
        }}>{`Refer here`}</a></li>
    </ul>
    <div class="relative">
      <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/commission1.png" alt="Commission" />
    </div>
    <div class="relative">
      <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/commission2.png" alt="Commission" />
    </div>
    <div class="relative">
      <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/commission3.png" alt="Commission" />
    </div>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">
        <p parentName="li">{`You can provide a custom name to this commision. It can be called as Service Charge or simple sales commission, etc. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You can configure a default fee if you don’t prefer a category level customisation. If there is category-based commission applied, the default fee will be overrides with this new fee. If there is a case when you have fifteen(15)categories, you have created category-based commission only for five(5) categories, other categories will take the default commission rate.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Enter a unique short code to identify this in your transactions list. Only Alphabets. Six letters. (Particularly used by Finance team)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`By default, it’s fixed commission for a particular category`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`But you can setup tier based commission for any category. Useful for high ticket items`}</p>
      </li>
    </ol>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
